import React from 'react'
import AirportList from '../../components/airports/AirportList';

const Airports = () => {
  return <AirportList />
}

export default Airports;
